module.exports = __webpack_public_path__ + "static/img/model-collect4.3d4088a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-collect4.png
// module id = FaGW
// module chunks = 36